<template>
  <div class="mian-info-tabs">
    <div class="mian-info-tabs-left"
         id="left">
      <div class="chart">
        <v-chart :options="recommendAssets"
                 style="width:48%;height: 300px;"></v-chart>
        <img class="Arrow"
             src="@/assets/images/wpsp/Customer-view/箭头右.png"
             alt="">
        <v-chart :options="proposalAssets"
                 style="width:48%;height: 300px;"></v-chart>
      </div>
      <div class="compare">
        <div>
          <div class="compare-left">
            <span class="circular"
                  style="background: rgba(165,168,172,1);"></span>
            <span class="text">货币类</span>
          </div>
          <span class="Proportion">{{currency.custRatio|fmtCustFinanceInfo}}%</span>
          <i class="el-icon-right"></i>
          <span class="Proportion">{{currency.recommended|fmtCustFinanceInfo}}%</span>
          <span :class="currency.custRatio-currency.recommended<0?'disparityTwo':'disparity'"
                v-if="currency.custRatio-currency.recommended!==0">
            <i :class="currency.custRatio-currency.recommended<0?'el-icon-top':'el-icon-bottom'">{{currency.result|fmtCustFinanceInfo}}%</i>
          </span>
          <span v-else
                class="disparityOne">-</span>
        </div>
        <div>
          <div class="compare-left">
            <span class="circular"
                  style="background: rgba(30, 136, 255, 0.8);"></span>
            <span class="text">固收类</span>
          </div>
          <span class="Proportion">{{fixedincome.custRatio|fmtCustFinanceInfo}}%</span>
          <i class="el-icon-right"></i>
          <span class="Proportion">{{fixedincome.recommended|fmtCustFinanceInfo}}%</span>
          <span :class="fixedincome.custRatio-fixedincome.recommended<0?'disparityTwo':'disparity'"
                v-if="fixedincome.custRatio-fixedincome.recommended!==0">
            <i :class="fixedincome.custRatio-fixedincome.recommended<0?'el-icon-top':'el-icon-bottom'">{{fixedincome.result|fmtCustFinanceInfo}}%</i>
          </span>
          <span v-else
                class="disparityOne">-</span>
        </div>
        <div>
          <div class="compare-left">
            <span class="circular"
                  style="background: rgba(52,200,139,1);"></span>
            <span class="text">权益类</span>
          </div>
          <span class="Proportion">{{rightsInterests.custRatio|fmtCustFinanceInfo}}%</span>
          <i class="el-icon-right"></i>
          <span class="Proportion">{{rightsInterests.recommended|fmtCustFinanceInfo}}%</span>
          <span :class="rightsInterests.custRatio-rightsInterests.recommended<0?'disparityTwo':'disparity'"
                v-if="rightsInterests.custRatio-rightsInterests.recommended!==0">
            <i :class="rightsInterests.custRatio-rightsInterests.recommended<0?'el-icon-top':'el-icon-bottom'">{{rightsInterests.result|fmtCustFinanceInfo}}%</i>
          </span>
          <span v-else
                class="disparityOne">-</span>
        </div>
        <div>
          <div class="compare-left">
            <span class="circular"
                  style="background:rgba(250,183,72,1);"></span>
            <span class="text">商品类</span>
          </div>
          <span class="Proportion">{{commodity.custRatio|fmtCustFinanceInfo}}%</span>
          <i class="el-icon-right"></i>
          <span class="Proportion">{{commodity.recommended|fmtCustFinanceInfo}}%</span>
          <span :class="commodity.custRatio-commodity.recommended<0?'disparityTwo':'disparity'"
                v-if="commodity.custRatio-commodity.recommended!==0">
            <i :class="commodity.custRatio-commodity.recommended<0?'el-icon-top':'el-icon-bottom'">{{commodity.result|fmtCustFinanceInfo}}%</i>
          </span>
          <span v-else
                class="disparityOne">-</span>
        </div>
        <div class="chart-bottom-text">
          <div class="outerLayer">
            <el-row>
              <el-col :span="2">
                <div class="background">1</div>
              </el-col>
              <el-col :span="22">
                本方案是按照符合客户的风险偏好及风险承受能力的原则，基于市场上的投资产品普遍风险特征，
                <span class="Thickening">{{textOne}}
                </span>
              </el-col>
            </el-row>
          </div>
          <el-row v-for=" (v,i) in textTwo"
                  :key="v"
                  class="outerLayer">
            <el-col :span="2">
              <div class="background">{{i+2}}</div>
            </el-col>
            <el-col :span="22"
                    v-html="v">
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="right">
      <span class="text">推荐产品</span>
      <!-- 货币类 -->
      <div class="Solid-recovery"
           style="margin-top: 15px;"
           v-if="currency.show">
        <div class="background"
             style="background:rgba(245,247,250,1);">
          货币类({{currency.recommended|fmtCustFinanceInfo}}%)</div>
        <div class="product-bottom">
          <div v-if="currency.Subitem[0].recommended!==0">
            <el-row>
              <el-col :span="8">
                <p class="product-type"
                   style="background: rgba(241, 247, 255, 1);">
                  {{currency.Subitem[0].name}}
                  ({{currency.Subitem[0].recommended|fmtCustFinanceInfo}}%)</p>
              </el-col>
              <el-col :span="6">
                <p class="product-content">七日年化</p>
              </el-col>
              <el-col :span="6">
                <p class="product-content">万份收益</p>
              </el-col>
              <el-col :span="4">
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <p>{{currency.Subitem[0].product.prdName}}</p>
              </el-col>
              <el-col :span="6">
                <p class="color">{{(currency.Subitem[0].product.weekAnnualYield*1).toFixed(4)}}%</p>
              </el-col>
              <el-col :span="6">
                <p>{{currency.Subitem[0].product.tenKiolYield|addMoneyFilter}}</p>
              </el-col>
              <el-col :span="4">
                <el-button type="text"
                           @click="replacementProducts('1')">替换产品</el-button>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <!-- 固收类 -->
      <div class="Solid-recovery"
           v-if="fixedincome.show">
        <div class="background"
             style="background: rgba(241, 247, 255, 1);">
          固收类({{fixedincome.recommended|fmtCustFinanceInfo}}%)</div>
        <div class="product-bottom">
          <div v-if="fixedincome.Subitem[0].recommended!==0">
            <el-row>
              <el-col :span="8">
                <p class="product-type"
                   style="background: rgba(241, 247, 255, 1);">
                  {{fixedincome.Subitem[0].name}}
                  ({{fixedincome.Subitem[0].recommended|fmtCustFinanceInfo}}%)</p>
              </el-col>
              <el-col :span="6">
                <p class="product-content">业绩比较基准</p>
              </el-col>
              <el-col :span="6">
                <p class="product-content">起投金额</p>
              </el-col>
              <el-col :span="4">
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <p>{{fixedincome.Subitem[0].product.prdName}}</p>
              </el-col>
              <el-col :span="6">
                <p class="color">
                  {{fixedincome.Subitem[0].product.performanceCriterionFloor.toFixed(4)}}%
                  -{{fixedincome.Subitem[0].product.performanceCriterionCeiling.toFixed(4)}}%</p>
              </el-col>
              <el-col :span="6">
                <p>{{fixedincome.Subitem[0].product.purchaseAmounts|addMoneyFilter}}元</p>
              </el-col>
              <el-col :span="4">
                <el-button type="text"
                           @click="replacementProducts('6')">替换产品</el-button>
              </el-col>
            </el-row>
          </div>
          <div v-if="fixedincome.Subitem[1].recommended!==0">
            <el-row>
              <el-col :span="8">
                <p class="product-type"
                   style="background: rgba(241, 247, 255, 1);">
                  {{fixedincome.Subitem[1].name}}
                  ({{fixedincome.Subitem[1].recommended|fmtCustFinanceInfo}}%)</p>
              </el-col>
              <el-col :span="6">
                <p class="product-content">到期收益率</p>
              </el-col>
              <el-col :span="6">
                <p class="product-content">到期日</p>
              </el-col>
              <el-col :span="4">
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <p>{{fixedincome.Subitem[1].product.prdName||'-'}}</p>
              </el-col>
              <el-col :span="6">
                <p class="color">{{(fixedincome.Subitem[1].product.extentOfMonth*1).toFixed(4)}}%</p>
              </el-col>
              <el-col :span="6">
                <p>{{fixedincome.Subitem[1].product.expireDate||'-'}}</p>
              </el-col>
              <el-col :span="4">
                <el-button type="text"
                           @click="replacementProducts('7')">替换产品</el-button>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <!-- 权益类 -->
      <div class="Equity"
           v-if="rightsInterests.show">
        <div class="background"
             style="background:rgba(2,187,111,0.1);">
          权益类({{rightsInterests.recommended|fmtCustFinanceInfo}}%)</div>
        <div class="product-bottom">
          <div v-if="rightsInterests.Subitem[0].recommended!==0">
            <el-row>
              <el-col :span="8">
                <p class="product-type"
                   style="background: rgba(2,187,111,0.1);">
                  {{rightsInterests.Subitem[0].name}}
                  ({{rightsInterests.Subitem[0].recommended|fmtCustFinanceInfo}}%)</p>
              </el-col>
              <el-col :span="6">
                <p class="product-content">单位净值</p>
              </el-col>
              <el-col :span="6">
                <p class="product-content">近一月涨幅</p>
              </el-col>
              <el-col :span="4">
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <p>{{rightsInterests.Subitem[0].product.prdName}}</p>
              </el-col>
              <el-col :span="6">
                <p class="color">
                  {{rightsInterests.Subitem[0].product.newsetNetValue.toFixed(4)}}</p>
              </el-col>
              <el-col :span="6">
                <p>-</p>
              </el-col>
              <el-col :span="4">
                <el-button type="text"
                           @click="replacementProducts('11')">替换产品</el-button>
              </el-col>
            </el-row>
          </div>
          <div v-if="rightsInterests.Subitem[1].recommended!==0">
            <el-row>
              <el-col :span="8">
                <p class="product-type"
                   style="background: rgba(2,187,111,0.1);">
                  {{rightsInterests.Subitem[1].name}}
                  ({{rightsInterests.Subitem[1].recommended|fmtCustFinanceInfo}}%)</p>
              </el-col>
              <el-col :span="6">
                <p class="product-content">单位净值</p>
              </el-col>
              <el-col :span="6">
                <p class="product-content">近一月涨幅</p>
              </el-col>
              <el-col :span="4">
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <p>{{rightsInterests.Subitem[1].product.prdName}}</p>
              </el-col>
              <el-col :span="6">
                <p class="color">
                  {{rightsInterests.Subitem[1].product.newsetNetValue.toFixed(4)}}</p>
              </el-col>
              <el-col :span="6">
                <p>-</p>
              </el-col>
              <el-col :span="4">
                <el-button type="text"
                           @click="replacementProducts('12')">替换产品</el-button>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <!-- 商品类 -->
      <div class="Solid-recovery"
           v-if="commodity.show">
        <div class="background"
             style="background:rgba(250,166,28,0.1);">
          商品类({{commodity.recommended|fmtCustFinanceInfo}}%)</div>
        <div class="product-bottom bottom-border">
          <div v-if="commodity.Subitem[0].recommended!==0">
            <el-row>
              <el-col :span="8">
                <p class="product-type"
                   style="background: rgba(241, 247, 255, 1);">
                  {{commodity.Subitem[0].name}}
                  ({{commodity.Subitem[0].recommended|fmtCustFinanceInfo}}%)</p>
              </el-col>
              <el-col :span="6">
                <p class="product-content">单位净值</p>
              </el-col>
              <el-col :span="6">
                <p class="product-content">近一月涨幅</p>
              </el-col>
              <el-col :span="4">
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <p>{{commodity.Subitem[0].product.prdName}}</p>
              </el-col>
              <el-col :span="6">
                <p class="color">{{commodity.Subitem[0].product.newsetNetValue.toFixed(4)}}</p>
              </el-col>
              <el-col :span="6">
                <p>-</p>
              </el-col>
              <el-col :span="4">
                <el-button type="text"
                           @click="replacementProducts('14')">替换产品</el-button>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <div class="report">
      <!-- 封面 -->
      <div id="cover">
        <div class="img">
          <img src="../../../assets/images/wpsp/cover.png">
        </div>
        <div class="text">
          <p>个人财富规划报告</p>
          <p>Personal Financial Planning Report</p>
        </div>
        <div class="logo">
          <img src="../../../assets/images/wpsp/coverlogo.png">
        </div>
      </div>
      <!-- 页眉 -->
      <div id="header">
        <div class="top">
          <div style="width:114px">
            <img src="../../../assets/images/wpsp/coverlogo.png">
          </div>
          <div class="text">
            个人财富规划报告
          </div>
          <div style="width:114px"></div>
        </div>
      </div>
      <!-- 页脚 -->
      <div id="footer">
        <div class="top">
          <span>客户姓名：{{customer.custName}}</span>
          <span>-{{pages}}-</span>
          <span>客户经理：{{sessionData.userName}}</span>
        </div>
      </div>
      <div id="statement">
        <div class="title">第一部分 声明</div>
        <div class="division"></div>
        <p>尊敬的{{customer.custName}}{{customer.gender==='1'?'先生':'女士'}}:</p>
        <p class="indent">您好!感谢您对{{sessionData.orgnName}}的信任。 </p>
        <p class="indent">我们的职责是准确评估您的财务需求，按照符合您的利益和风险承受能力的原则，为您提供高质量的财务建议和长期的金融服务。</p>
        <p class="indent">本资产配置报告是在您提供的资料基础上，基于当前的经济环境作出的合理假设，综合考虑您的基本家庭信息、财务状况、风险承受能力、理财目标等因素所制定的。希望通过我们为您提供的理财服务，您和您的家庭将进一步提升生活品质，并能更加从容潇洒地面对生活，尽早实现财务自由。</p>
        <p class="indent">您所提供信息的完整性、真实性将有利于我们为您更全面的完成资产配置建议，提供更好的理财服务，请您仔细阅读本报告，以确保信息的准确无误。按照理财从业人员的行为准则，我们将对您的家庭资料严格保密。</p>
        <p class="indent">当您目前的生活状况发生变化时，请及时与我行联系，我们将及时对您的理财计划进行调整。 </p>
        <p class="indent">如果您有任何理财需求问题，欢迎您致电或亲临我行营业网点，我们将竭诚为您服务!</p>
        <div class="bottom">
          <p>{{currentDate}}</p>
          <p>客户经理：{{sessionData.userName}}</p>
        </div>
      </div>
      <!--step 2 基本状况介绍-->
      <div class="step"
           id="step">
        <div class="title">第二部分 基本状况介绍</div>
        <div class="division"></div>
        <div class="title"><i class="el-icon-caret-right"></i>家庭关系</div>
        <div class="contentOne">
          <div class="relationship">
            <span>姓名：{{customer.custName}}</span>
            <span>学历：{{dropDown.education|educationFilter}}</span>
            <span>职业：{{dropDown.occupation|occupationFilter}}</span>
            <span>投资经验：{{dropDown.investExperience|investmentKnowledgeFilter}}</span>
            <span>投资知识：{{dropDown.investKnowledge|investmentExperienceFilter}}</span>
          </div>
          <el-row class="Header">
            <el-col :span="8">
              <div>姓名</div>
            </el-col>
            <el-col :span="8"
                    class="Header-division">
              <div>年龄</div>
            </el-col>
            <el-col :span="8">
              <div>关系</div>
            </el-col>
          </el-row>
          <el-row class="content"
                  v-for="(v,i) in allCustSupple"
                  :key="i"
                  :class="i%2===0?'background':''">
            <el-col :span="8">
              <div>{{v.custName}}</div>
            </el-col>
            <el-col :span="8"
                    class="Header-division">
              <div>{{v.custAge}}</div>
            </el-col>
            <el-col :span="8">
              <div>{{v.custRelation |familyRelationship}}</div>
            </el-col>
          </el-row>
          <p>在分析您家庭财务状况­和需求的基础上，结合分析您生活和职业特点，我们为您家庭制定了一份详实的理财规划，帮助您更好地规划人生。</p>
          <p>家庭理财就是在金融机构理财顾问的帮助下，通过确定家庭的财务目标，制定财务计划，运用各种理财工具，不断地积累和合理的运用财富，从而实现这些目标的过程。通过家庭理财，您可以降低或控制人生中面临的各类风险，提高生活质量和水平。</p>
          <p>基于您提供的信息，我们通过整理、分析和假设，将您的家庭情况罗列如下。我们将以此为基础开始理财规划。 </p>
          <div v-if="allCustSupple.custAge<=30">
            <p> 不同的家庭成长阶段会有不同财富积累方式和不同理财目标。都说万事开头难，理财同样如此。单身时期可以说是我们经济压力最小的时期，也是财富积累的起步期。这一时期的理财重点应该放在财富的获取方面。努力工作积累经验，加强工作能力，没有什么比提升自己的赚钱能力更重要的事，这也是今后财富收入的主要来源。多学习理财知识，节省开支，选择本金投入少的理财方式 </p>
          </div>
          <div v-else-if="allCustSupple.custAge<=40">
            <p> 不同的家庭成长阶段会有不同财富积累方式和不同理财目标。您正当风华正茂之年,说最主要的财务压力来自于建设家庭的费用，包括购房、购车、提升生活品质的物品等等，大多数都是需要长期完成，因此虽然财务压力提升，但是生活毕竟还是比较简单。理财重点大部分放在购置家庭资产方面，最好由两人共同完成生活消费等等，建立家庭账户管理共同财产。整合家庭财产和资产负债，制定家庭理财计划，选择高收益理财产品。同时还有助于培养两人感情和处理问题的能力。 </p>
          </div>
          <div v-else-if="allCustSupple.custAge<=50">
            <p> 不同的家庭成长阶段会有不同财富积累方式和不同理财目标。您已过不惑之年,说明您的家庭正处于家庭稳定期。处于家庭稳定期的家庭，收入不断提高，支出逐渐稳定，财富也将逐步增加。这一时期要处理好孩子的生活费用和下一阶段上学的费用，开源节流是关键。专门设立一个子女教育金账户，用来购置长期收益稳定并且安全的理财产品，作为今后子女教育资金储备。 </p>
          </div>
          <div v-else-if="allCustSupple.custAge<=60">
            <p> 不同的家庭成长阶段会有不同财富积累方式和不同理财目标。子女独立之后，家庭压力减轻，这时候工作能力和经济收入达到最高值，需要为自己的养老金做准备。 同时这一时期也是很多老年病的产生期，家庭理财规划要重新调整，准备好应对意外和生病的资金。理财重点放在财富的增值方面，制定养老规划，准备一个养老金账户，投资偏向保守型，可少量配置高风险高回报的投资。 </p>
          </div>
          <div v-else>
            <p> 不同的家庭成长阶段会有不同财富积累方式和不同理财目标。没有了工作的烦恼和子女的压力，这一时期的重点就是安度晚年，有些老年人退休后选择照看第三代，也有人选择旅行、游玩等等，无论怎样的生活方式都要有所节制，不要把辛辛苦苦积攒一辈子的钱都花掉，至少要留给自己足够的生活费和治病费。投资和消费都应该保守，安全稳定是关键，增加养老账户和看病账户的资金比例，尽量选择期限灵活的投资方式，给自己的晚年生活一份保障。</p>
          </div>
        </div>
        <div class="title"><i class="el-icon-caret-right"></i>风险属性说明</div>
        <div class="contentTwo">
          <p>根据对您的风险属性进行测试，您属于<span>{{allCustSupple.riskLevel}}</span>投资人。</p>
          <div>
            <span>
              <div class="ArrowShow"
                   v-if="allCustSupple.riskLevel==='低风险'"><i class="el-icon-caret-bottom"></i>低风险<i class="el-icon-caret-top"></i></div>
              <div class="Arrow"
                   v-if="allCustSupple.riskLevel!=='低风险'">低风险</div>
            </span>
            <span>
              <div class="ArrowShow"
                   v-if="allCustSupple.riskLevel==='中低风险'"><i class="el-icon-caret-bottom"></i>中低风险<i class="el-icon-caret-top"></i></div>
              <div class="Arrow"
                   v-if="allCustSupple.riskLevel!=='中低风险'">中低风险</div>
            </span>
            <span>
              <div class="ArrowShow"
                   v-if="allCustSupple.riskLevel==='中等风险'"><i class="el-icon-caret-bottom"></i>中等风险<i class="el-icon-caret-top"></i></div>
              <div class="Arrow"
                   v-if="allCustSupple.riskLevel!=='中等风险'">中等风险</div>
            </span>
            <span>
              <div class="ArrowShow"
                   v-if="allCustSupple.riskLevel==='中高风险'"><i class="el-icon-caret-bottom"></i>中高风险<i class="el-icon-caret-top"></i></div>
              <div class="Arrow"
                   v-if="allCustSupple.riskLevel!=='中高风险'">中高风险</div>
            </span>
            <span>
              <div class="ArrowShow"
                   v-if="allCustSupple.riskLevel==='高风险'"><i class="el-icon-caret-bottom"></i>高风险<i class="el-icon-caret-top"></i></div>
              <div class="Arrow"
                   v-if="allCustSupple.riskLevel!=='高风险'">高风险</div>
            </span>
          </div>
          <p v-if="allCustSupple.riskLevel==='低风险'">作为保守型的客户，您基本上不希望承受任何投资风险，因为您不愿承受任何投资损失。含投资成分的金融产品不适合您。</p>
          <p v-if="allCustSupple.riskLevel==='中低风险'">作为谨慎型的客户，您基本上接受轻微的损失，以换取轻微的潜在投资回报。适合您的产品的资本价值可能波动。</p>
          <p v-if="allCustSupple.riskLevel==='中等风险'">作为平衡型的客户，您基本上接受低程度的损失，以换取低程度的潜在投资回报。可能适合您的产品之资本价值可能波动并跌至低于您原本的投资额。</p>
          <p v-if="allCustSupple.riskLevel==='中高风险'">作为进取型的客户，您基本上接受高程度的损失，以换取高程度的潜在投资回报。资本价值可能有相当大幅的波动并跌至颇低于您原本的投资额。</p>
          <p v-if="allCustSupple.riskLevel==='高风险'">作为激进型的客户，您基本上接受极大的损失，以换取得极大的潜在投资回报。资本价值可能大幅波动并跌至远低于您原本的投资额。</p>
        </div>
      </div>
      <div id="allCustSupple">
        <div class="title">第二部分 资产配置建议</div>
        <div class="division"></div>
      </div>
      <div id="right">
        <span class="text">推荐产品组合</span>
        <!-- 货币类 -->
        <div class="Solid-recovery"
             style="margin-top: 15px;"
             v-if="currency.show">
          <div class="background"
               style="background:rgba(245,247,250,1);">
            货币类({{currency.recommended|fmtCustFinanceInfo}}%)</div>
          <div class="product-bottom">
            <div v-if="currency.Subitem[0].recommended!==0">
              <el-row>
                <el-col :span="8">
                  <p class="product-type"
                     style="background: rgba(241, 247, 255, 1);">
                    {{currency.Subitem[0].name}}
                    ({{currency.Subitem[0].recommended|fmtCustFinanceInfo}}%)</p>
                </el-col>
                <el-col :span="8">
                  <p class="product-content">七日年化</p>
                </el-col>
                <el-col :span="8">
                  <p class="product-content">万份收益</p>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <p>{{currency.Subitem[0].product.prdName}}</p>
                </el-col>
                <el-col :span="8">
                  <p class="color">
                    {{(currency.Subitem[0].product.weekAnnualYield*1).toFixed(4)}}%</p>
                </el-col>
                <el-col :span="8">
                  <p>{{currency.Subitem[0].product.tenKiolYield|addMoneyFilter}}</p>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <!-- 固收类 -->
        <div class="Solid-recovery"
             v-if="fixedincome.show">
          <div class="background"
               style="background: rgba(241, 247, 255, 1);">
            固收类({{fixedincome.recommended|fmtCustFinanceInfo}}%)</div>
          <div class="product-bottom">
            <div v-if="fixedincome.Subitem[0].recommended!==0">
              <el-row>
                <el-col :span="8">
                  <p class="product-type"
                     style="background: rgba(241, 247, 255, 1);">
                    {{fixedincome.Subitem[0].name}}
                    ({{fixedincome.Subitem[0].recommended|fmtCustFinanceInfo}}%)</p>
                </el-col>
                <el-col :span="8">
                  <p class="product-content">业绩比较基准</p>
                </el-col>
                <el-col :span="8">
                  <p class="product-content">起投金额</p>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <p>{{fixedincome.Subitem[0].product.prdName}}</p>
                </el-col>
                <el-col :span="8">
                  <p class="color">
                    {{fixedincome.Subitem[0].product.performanceCriterionFloor.toFixed(4)}}%
                    -{{fixedincome.Subitem[0].product.performanceCriterionCeiling.toFixed(4)}}</p>
                </el-col>
                <el-col :span="8">
                  <p>{{fixedincome.Subitem[0].product.purchaseAmounts|addMoneyFilter}}元</p>
                </el-col>
              </el-row>
            </div>
            <div v-if="fixedincome.Subitem[1].recommended!==0">
              <el-row>
                <el-col :span="8">
                  <p class="product-type"
                     style="background: rgba(241, 247, 255, 1);">
                    {{fixedincome.Subitem[1].name}}
                    ({{fixedincome.Subitem[1].recommended|fmtCustFinanceInfo}}%)</p>
                </el-col>
                <el-col :span="8">
                  <p class="product-content">到期收益率</p>
                </el-col>
                <el-col :span="8">
                  <p class="product-content">到期日</p>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <p>{{fixedincome.Subitem[1].product.prdName||'-'}}</p>
                </el-col>
                <el-col :span="8">
                  <p class="color">{{fixedincome.Subitem[1].product.extentOfMonth||'-'}}%</p>
                </el-col>
                <el-col :span="8">
                  <p>{{fixedincome.Subitem[1].product.expireDate||'-'}}</p>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <!-- 权益类 -->
        <div class="Equity"
             v-if="rightsInterests.show">
          <div class="background"
               style="background:rgba(2,187,111,0.1);">
            权益类({{rightsInterests.recommended|fmtCustFinanceInfo}}%)</div>
          <div class="product-bottom">
            <div v-if="rightsInterests.Subitem[0].recommended!==0">
              <el-row>
                <el-col :span="8">
                  <p class="product-type"
                     style="background: rgba(2,187,111,0.1);">
                    {{rightsInterests.Subitem[0].name}}
                    ({{rightsInterests.Subitem[0].recommended|fmtCustFinanceInfo}}%)</p>
                </el-col>
                <el-col :span="8">
                  <p class="product-content">单位净值</p>
                </el-col>
                <el-col :span="8">
                  <p class="product-content">近一月涨幅</p>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <p>{{rightsInterests.Subitem[0].product.prdName}}</p>
                </el-col>
                <el-col :span="8">
                  <p class="color">
                    {{rightsInterests.Subitem[0].product.newsetNetValue.toFixed(4)}}</p>
                </el-col>
                <el-col :span="8">
                  <p>-</p>
                </el-col>
              </el-row>
            </div>
            <div v-if="rightsInterests.Subitem[1].recommended!==0">
              <el-row>
                <el-col :span="8">
                  <p class="product-type"
                     style="background: rgba(2,187,111,0.1);">
                    {{rightsInterests.Subitem[1].name}}
                    ({{rightsInterests.Subitem[1].recommended|fmtCustFinanceInfo}}%)</p>
                </el-col>
                <el-col :span="8">
                  <p class="product-content">单位净值</p>
                </el-col>
                <el-col :span="8">
                  <p class="product-content">近一月涨幅</p>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <p>{{rightsInterests.Subitem[1].product.prdName}}</p>
                </el-col>
                <el-col :span="8">
                  <p class="color">
                    {{rightsInterests.Subitem[1].product.newsetNetValue.toFixed(4)}}</p>
                </el-col>
                <el-col :span="8">
                  <p>-</p>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <!-- 商品类 -->
        <div class="Solid-recovery"
             v-if="commodity.show">
          <div class="background"
               style="background:rgba(250,166,28,0.1);">
            商品类({{commodity.recommended|fmtCustFinanceInfo}}%)</div>
          <div class="product-bottom bottom-border">
            <div v-if="commodity.Subitem[0].recommended!==0">
              <el-row>
                <el-col :span="8">
                  <p class="product-type"
                     style="background: rgba(241, 247, 255, 1);">
                    {{commodity.Subitem[0].name}}
                    ({{commodity.Subitem[0].recommended|fmtCustFinanceInfo}}%)</p>
                </el-col>
                <el-col :span="8">
                  <p class="product-content">单位净值</p>
                </el-col>
                <el-col :span="8">
                  <p class="product-content">近一月涨幅</p>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <p>{{commodity.Subitem[0].product.prdName}}</p>
                </el-col>
                <el-col :span="8">
                  <p class="color">{{commodity.Subitem[0].product.newsetNetValue.toFixed(4)}}</p>
                </el-col>
                <el-col :span="8">
                  <p>-</p>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
      <!--step 10 免责条款-->
      <div class="step"
           id="ExemptionClause">
        <div class="title">第四部分 免责条款</div>
        <div class="division"></div>
        <p>1. 本个人综合理财规划报告是为协助您理清财务需求
          及目标而设计的，使您能在充分的信息下做理财决策。
          本策划是依据您所提供的资料及若干一般可接受的假设，
          再加上合理的预估来推算结果。这是免费提供给您的非义
          务服务。 </p>
        <p>2. 本个人综合理财规划报告仅在您决策如何以最佳方式达
          成财务目标时用作指导。本个人综合理财规划报告无意取代
          财务咨询或规划服务。如果您有与财务相关的问题，应请教
          合格的财务顾问。所有的计算及假设都是基于您目前的财务
          状况及现今的经济环境而来。这两者都是会产生变化的。本
          人建议您定期审视您的财务目标和规划，特别是当您的婚姻
          状况改变或家庭成员增加时更需如此。</p>
        <p>3. 投资产品并非存款，本人对其不负有义务或承担保证或
          保险责任，并且这些投资产品存在投资 风险，其中包括可能
          损失投入本金在内。过去的绩效并不说明未来的绩效，价格
          可能上扬或下跌。 </p>
        <p>4. 本个人综合理财规划报告所得的结果是基于您所提供的
          信息及假设得来的。您所提供的信息越精准，越 有助于评估
          的结果。本个人综合理财规划报告仅用作指导，不能代替专业
          的税务、法务建议。</p>
        <p> 5. 由于地震、火灾、战争等其他各种不可抗力因素引起的
          经济损失国工商银行不承担任何经济和法律责任。</p>
        <p> 6. 本免责条款的最终解释权属{{sessionData.orgnName}}。</p>
      </div>
    </div>
    <el-dialog title="替换产品"
               :visible.sync="dialogTableVisible"
               :show-close="false"
               :close-on-press-escape="false"
               :close-on-click-modal="false"
               width="85%">
      <el-form :inline="true"
               :model="formInline"
               :rules="rules"
               ref="ruleForm"
               class="demo-form-inline demo-ruleForm">
        <el-form-item label="产品代码"
                      prop="prdCode">
          <el-input v-model="formInline.prdCode"
                    placeholder="产品代码"></el-input>
        </el-form-item>
        <el-form-item label="产品名称"
                      prop="prdName">
          <el-input v-model="formInline.prdName"
                    placeholder="产品名称"></el-input>
        </el-form-item>
        <el-form-item label="风险类型"
                      prop="riskLevel"
                      v-if="productType==='1'||productType==='7'||productType==='11'
                      ||productType==='12'||productType==='14'">
          <el-select v-model="formInline.riskLevel"
                     placeholder="请选择">
            <el-option v-for="item in riskLevelList"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="起存金额(元)"
                      v-if="productType==='6'">
          <el-input v-model="formInline.name"
                    placeholder="起存金额(元)"></el-input>
        </el-form-item> -->
        <el-form-item label="起购金额(元)"
                      prop="purchaseAmountsFloor">
          <!-- <el-input v-model="formInline.purchaseAmounts"
                    placeholder="起购金额(元)"></el-input> -->
                     <el-col :span="11">
            <el-input v-model="formInline.purchaseAmountsFloor"
                      placeholder="下限"></el-input>
          </el-col>
          <el-col class="line"
                  :span="2" style="text-align: center;">-</el-col>
          <el-col :span="11">
            <el-input v-model="formInline.purchaseAmountsCeiling"
                      placeholder="上限"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="产品状态"
                      prop="status">
          <el-select v-model="formInline.status"
                     placeholder="请选择">
            <el-option v-for="item in statusList"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否置顶"
                      prop="topFlag">
          <el-select v-model="formInline.topFlag"
                     placeholder="请选择">
            <el-option v-for="item in topFlagList"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="投资期限(天)"
                      prop="investTermFloor"
                      v-if="productType==='6'">
          <!-- <el-input v-model="formInline.investTerm"
                    placeholder="投资期限(天)"></el-input> -->
          <el-col :span="11">
            <el-input v-model="formInline.investTermFloor"
                      placeholder="下限"></el-input>
          </el-col>
          <el-col class="line"
                  :span="2" style="text-align: center;">-</el-col>
          <el-col :span="11">
            <el-input v-model="formInline.investTermCeiling"
                      placeholder="上限"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="收益类型"
                      prop="yieldType"
                      v-if="productType==='6'">
          <el-select v-model="formInline.yieldType"
                     placeholder="请选择">
            <el-option v-for="item in yieldTypeList"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="风险等级"
                      prop="riskLevel"
                      v-if="productType==='6'">
          <el-select v-model="formInline.riskLevel"
                     placeholder="请选择">
            <el-option v-for="item in riskLevelList"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          <!-- <el-input v-model="formInline.riskLevel"
                    placeholder="风险等级"></el-input> -->
        </el-form-item>
      </el-form>
      <el-button type="primary"
                 @click="replaceDataList('ruleForm')">查询</el-button>
      <el-button @click="emptyFormInline('ruleForm')">清空</el-button>
      <el-table :data="gridData"
                ref="multipleTable"
                highlight-current-row
                @selection-change="handleCurrentChange">
        <el-table-column type="selection"
                         width="55">
        </el-table-column>
        <el-table-column property="code"
                         label="产品代码">
          <template slot-scope="scope">
            <span>{{ scope.row.prdCode }}</span>
          </template>
        </el-table-column>
        <el-table-column label="产品名称">
          <template slot-scope="scope">
            <span>{{ scope.row.prdName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="产品状态">
          <template slot-scope="scope">
            <span>{{ scope.row.statusRes }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否置顶">
          <template slot-scope="scope">
            <span>{{ scope.row.topFlagRes }}</span>
          </template>
        </el-table-column>
        <el-table-column label="起购金额(元)"
                         v-if="productType==='6'"
                         width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.purchaseAmounts |addMoneyFilter}}</span>
          </template>
        </el-table-column>
        <el-table-column label="投资期限"
                         v-if="productType==='6'">
          <template slot-scope="scope">
            <span>{{ scope.row.investTerm }}天</span>
          </template>
        </el-table-column>
        <el-table-column label="预期年化收益率（下限）"
                         v-if="productType==='6'"
                         width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.expAnnualYieldFloor }}%</span>
          </template>
        </el-table-column>
        <el-table-column label="预期年化收益率（上限）"
                         v-if="productType==='6'"
                         width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.expAnnualYieldCeiling }}%</span>
          </template>
        </el-table-column>
        <el-table-column label="业绩比较基准（下限）"
                         v-if="productType==='6'"
                         width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.performanceCriterionFloor|fmtCustFinanceInfoTwo }}%</span>
          </template>
        </el-table-column>
        <el-table-column label="业绩比较基准（上限）"
                         v-if="productType==='6'"
                         width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.performanceCriterionCeiling|fmtCustFinanceInfoTwo }}%</span>
          </template>
        </el-table-column>
        <el-table-column label="七日年化收益率"
                         v-if="productType==='6'"
                         width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.weekAnnualYield }}%</span>
          </template>
        </el-table-column>
        <el-table-column label="最新净值"
                         v-if="productType==='6'">
          <template slot-scope="scope">
            <span>{{ scope.row.newsetNetValue|fmtCustFinanceInfoTwo }}</span>
          </template>
        </el-table-column>
        <el-table-column label="可售余额"
                         v-if="productType==='6'"
                         width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.remainAmounts |addMoneyFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column label="收益类型"
                         v-if="productType==='6'">
          <template slot-scope="scope">
            <span>{{ scope.row.yieldTypeRes }}</span>
          </template>
        </el-table-column>
        <el-table-column label="风险等级"
                         v-if="productType==='6'">
          <template slot-scope="scope">
            <span>{{ scope.row.riskLevelRes }}</span>
          </template>
        </el-table-column>
        <el-table-column label="运作模式"
                         v-if="productType==='6'">
          <template slot-scope="scope">
            <span>{{ scope.row.operationModeRes }}</span>
          </template>
        </el-table-column>
        <el-table-column label="投资资产类型"
                         v-if="productType==='6'"
                         width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.investAssetClassRes }}</span>
          </template>
        </el-table-column>
        <el-table-column label="募集开始日"
                         v-if="productType==='6'"
                         width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.ipoStartDate |formatDateTwo}}</span>
          </template>
        </el-table-column>
        <el-table-column label="募集结束日"
                         v-if="productType==='6'"
                         width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.ipoEndDate |formatDateTwo}}</span>
          </template>
        </el-table-column>
        <el-table-column label="产品成立日"
                         v-if="productType==='6'"
                         width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.establishDate |formatDateTwo}}</span>
          </template>
        </el-table-column>
        <el-table-column label="产品到期日"
                         v-if="productType==='6'"
                         width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.expireDate |formatDateTwo}}</span>
          </template>
        </el-table-column>
        <el-table-column label="单位净值"
                         v-if="productType==='1'||productType==='7'||productType==='11'
                      ||productType==='12'||productType==='14'">
          <template slot-scope="scope">
            <span>{{ scope.row.newsetNetValue |fmtCustFinanceInfoTwo}}</span>
          </template>
        </el-table-column>
        <el-table-column label="万份收益"
                         v-if="productType==='1'||productType==='7'||productType==='11'
                      ||productType==='12'||productType==='14'">
          <template slot-scope="scope">
            <span>{{ scope.row.tenKiolYield |fmtCustFinanceInfoTwo}}</span>
          </template>
        </el-table-column>
        <el-table-column label="七日年化"
                         v-if="productType==='1'||productType==='7'||productType==='11'
                      ||productType==='12'||productType==='14'">
          <template slot-scope="scope">
            <span>{{ scope.row.weekAnnualYield*100 |fmtCustFinanceInfoTwo}}%</span>
          </template>
        </el-table-column>
        <el-table-column label="累计净值"
                         v-if="productType==='1'||productType==='7'||productType==='11'
                      ||productType==='12'||productType==='14'">
          <template slot-scope="scope">
            <span>{{ scope.row.accumultedNetValue |fmtCustFinanceInfoTwo}}</span>
          </template>
        </el-table-column>
        <el-table-column label="近一日涨幅"
                         v-if="productType==='1'||productType==='7'||productType==='11'
                      ||productType==='12'||productType==='14'"
                         width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.aa||'-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="近一周涨幅"
                         v-if="productType==='1'||productType==='7'||productType==='11'
                      ||productType==='12'||productType==='14'"
                         width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.aa||'-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="近一月涨幅"
                         v-if="productType==='1'||productType==='7'||productType==='11'
                      ||productType==='12'||productType==='14'"
                         width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.aa||'-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="近半年涨幅"
                         v-if="productType==='1'||productType==='7'||productType==='11'
                      ||productType==='12'||productType==='14'"
                         width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.aa||'-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="成立以来"
                         v-if="productType==='1'||productType==='7'||productType==='11'
                      ||productType==='12'||productType==='14'">
          <template slot-scope="scope">
            <span>{{ scope.row.aa||'-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="起投金额(元)"
                         v-if="productType==='1'||productType==='7'||productType==='11'
                      ||productType==='12'||productType==='14'"
                         width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.aa||'-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="风险类型"
                         v-if="productType==='1'||productType==='7'||productType==='11'
                      ||productType==='12'||productType==='14'">
          <template slot-scope="scope">
            <span>{{ scope.row.riskLevelRes }}</span>
          </template>
        </el-table-column>
        <el-table-column label="基金规模(元)"
                         v-if="productType==='1'||productType==='7'||productType==='11'
                      ||productType==='12'||productType==='14'"
                         width="110">
          <template slot-scope="scope">
            <span>{{ scope.row.aa||'-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="基金成立日"
                         v-if="productType==='1'||productType==='7'||productType==='11'
                      ||productType==='12'||productType==='14'"
                         width="110">
          <template slot-scope="scope">
            <span>{{ scope.row.establishDate |formatDateTwo}}</span>
          </template>
        </el-table-column>
      </el-table>
      <yh-pagination :page.sync="currentPage"
                     :total="sumCount" />
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="dialogTableVisible = false,currentPage=1,emptyFormInline()">取 消</el-button>
        <el-button type="primary"
                   @click="determineReplacement">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export default {
  data() {
    const purchaseAmountsFloor = (rule, value, callback) => {
      if (isNaN(value) && value !== '') {
        callback(new Error('请输入数字'));
      }
      if (
        isNaN(this.formInline.purchaseAmountsCeiling)
        && this.formInline.purchaseAmountsCeiling !== ''
      ) {
        callback(new Error('请输入数字区间'));
      }
      if (
        (value * 1) > (this.formInline.purchaseAmountsCeiling * 1)
      ) {
        callback(new Error('起购金额上限金额不能小于下限金额'));
      }
      callback();
    };
    const investTermFloor = (rule, value, callback) => {
      if (isNaN(value) && value !== '') {
        callback(new Error('请输入数字区间'));
      }
      if (
        isNaN(this.formInline.investTermCeiling)
        && this.formInline.investTermCeiling !== ''
      ) {
        callback(new Error('请输入数字区间'));
      }
      if (
        (value * 1) > (this.formInline.investTermCeiling * 1)
      ) {
        callback(new Error('投资期限上限天数不能小于下限天数'));
      }
      callback();
    };
    return {
      // eslint-disable-next-line new-cap
      pdf: new jsPDF('', 'pt', 'a4'),
      proposalAssets: {}, // 推荐饼图数据
      recommendAssets: {}, // 个人饼图数据
      dialogTableVisible: false,
      // 总数
      sumCount: 0,
      // 当前页数
      currentPage: 1,
      // 每页数量
      pageSize: 10,
      productType: '1',
      formInline: {
        prdCode: '',
        prdName: '',
        riskLevel: '',
        investTermFloor: '',
        investTermCeiling: '',
        purchaseAmountsFloor: '',
        purchaseAmountsCeiling: '',
        status: '',
        topFlag: '',
        investTerm: '',
        yieldType: '',
        isTop: '',
      },
      statusList: [
        {
          value: '1',
          label: '预售',
        },
        {
          value: '2',
          label: '在售',
        },
        {
          value: '3',
          label: '售罄',
        },
        {
          value: '4',
          label: '停售',
        },
        {
          value: '5',
          label: '存续',
        },
      ],
      topFlagList: [
        {
          value: '1',
          label: '是',
        },
        {
          value: '0',
          label: '否',
        },
      ],
      isTopList: [
        {
          value: '1',
          label: '是',
        },
        {
          value: '0',
          label: '否',
        },
      ],
      yieldTypeList: [
        {
          value: '1',
          label: '保证收益',
        },
        {
          value: '2',
          label: '保本浮动收益',
        },
        {
          value: '3',
          label: '非保本浮动收益',
        },
      ],
      riskLevelList: [
        {
          value: 'R1',
          label: '低风险',
        },
        {
          value: 'R2',
          label: '中低风险',
        },
        {
          value: 'R3',
          label: '中等风险',
        },
        {
          value: 'R4',
          label: '中高风险',
        },
        {
          value: 'R5',
          label: '高风险',
        },
      ],
      gridData: [],
      sessionData: JSON.parse(sessionStorage.getItem('sessionData')), // 理财经理信息
      customer: JSON.parse(sessionStorage.getItem('customer')), // 客户信息
      pages: 1, // 当前pdf页数
      footerW: '',
      footerH: '',
      footerImg: '',
      selectData: {}, // 替换产品列表选中的产品
      // 替换信息
      textOne: '',
      // 配置比例显示的文字
      textTwo: [],
      configureData: [],
      // 货币类推荐比例数据
      currency: {
        show: true, // 是否显示
        recommended: 25, // 推荐比例
        custRatio: 0, // 客户现有比例
        result: 0, // 差
        Subitem: [
          // 子项
          {
            name: '货币型基金',
            prdCategory: '1',
            recommended: 0,
            product: {},
          },
        ],
      },
      // 固收类推荐比例数据
      fixedincome: {
        show: true, // 是否显示
        recommended: 25, // 推荐比例
        custRatio: 0, // 客户现有比例
        result: 0, // 差
        Subitem: [
          // 子项
          {
            name: '银行理财',
            prdCategory: '6',
            recommended: 0,
            product: {},
          },
          {
            name: '债券型基金',
            prdCategory: '7',
            recommended: 0,
            product: {},
          },
        ],
      },
      // 权益类推荐比例数据
      rightsInterests: {
        show: true, // 是否显示
        recommended: 25, // 推荐比例
        custRatio: 0, // 客户现有比例
        result: 0, // 差
        Subitem: [
          // 子项
          {
            name: '混合型基金',
            prdCategory: '11',
            recommended: 0,
            product: {},
          },
          {
            name: '股票型基金',
            prdCategory: '12',
            recommended: 0,
            product: {},
          },
        ],
      },
      // 商品类推荐比例数据
      commodity: {
        show: true, // 是否显示
        recommended: 25, // 推荐比例
        custRatio: 0, // 客户现有比例
        result: 0, // 差
        Subitem: [
          // 子项
          {
            name: '黄金ETF连接基金',
            prdCategory: '14',
            recommended: 0,
            product: {},
          },
        ],
      },
      // 当前系统时间
      currentDate: '',
      loading: '',
      allCustSupple: [],
      dropDown: {},
      rules: {
        purchaseAmountsFloor: [{ validator: purchaseAmountsFloor, trigger: 'blur' }],
        investTermFloor: [{ validator: investTermFloor, trigger: 'blur' }],
      },
    };
  },
  props: ['riskLevel', 'tabs'],
  watch: {
    currentPage() {
      this.replaceDataList();
    },
  },
  mounted() {
    // 接受父页面发来的信息
    window.addEventListener('message', (event) => {
      const { data } = event;
    });
    const myDate = new Date();
    this.currentDate = `${myDate.getFullYear()}-${
      myDate.getMonth() + 1
    }-${myDate.getDate()}`;
    if (this.tabs === '1') {
      this.textOne = '追求收益、风险相对平衡，达到保值增值的理财目的。';
    } else if (this.tabs === '2') {
      this.textOne = '在风险可承受范围内，达到利益最大化。';
    } else {
      this.textOne = '在保证一定收益的前提下，最大程度规避各类潜在风险。';
    }
    if (this.riskLevel === 'R1') {
      this.rightsInterests.show = false;
      this.commodity.show = false;
    } else if (this.riskLevel === 'R2') {
      this.commodity.show = false;
    } else if (this.riskLevel === 'R5') {
      if (this.tabs === '3') {
        this.currency.show = false;
      }
    }
    this.getDetail();
    this.prdUnitList();
  },
  methods: {
    // 默认配置
    default() {
      this.$confirm('恢复默认配置，将取消当前所有操作，请您确认', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          const parames = {
            data: {
              cis: JSON.parse(sessionStorage.getItem('customer')).cis,
            },
          };
          this.$_post(this.$API.recoveryDefault, parames).then((res) => {
            if (res.errorCode === 'E00000') {
              // 向父vue页面发送信息
              window.parent.postMessage({
                cmd: 'returnHeight',
                params: {
                  success: true,
                  data: this.customer.cis,
                },
              }, '*');
            }
            this.$message({
              message: res.errorMsg,
              type: 'success',
            });
            this.getDetail();
            this.prdUnitList();
          });
        })
        .catch(() => {
        });
    },
    emptyFormInline(formName) {
      if (formName !== undefined) {
        this.$refs[formName].resetFields();
      }
      this.formInline = {
        prdCode: '',
        prdName: '',
        riskLevel: '',
        purchaseAmounts: '',
        investTermFloor: '',
        investTermCeiling: '',
        purchaseAmountsFloor: '',
        purchaseAmountsCeiling: '',
        status: '',
        topFlag: '',
        investTerm: '',
        yieldType: '',
        isTop: '',
      };
    },
    // 请求资产饼图
    getDetail() {
      const parames = {
        data: {
          scheme: this.tabs - 1, // 方案（0.标准  1.提收益  2.降风险）
          riskPreference: this.riskLevel.replace(/R/g, ''), // 风险等级（1.保守型 2.谨慎型 3.平衡型 4.进取型 5.激进型）
          cis: JSON.parse(sessionStorage.getItem('customer')).cis,
          isSelf: '0', // 是否为本人（1.本人 2.配偶）
        },
      };
      this.$_post(this.$API.get_detail, parames).then((res) => {
        const proposalData = [];
        const recommendData = [];
        this.textTwo = [];
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < res.data.info.length; i++) {
          if (res.data.info[i].assetsClass === '1') {
            this.currency.custRatio = res.data.info[i].custRatio * 100; // 客户现有比例
            this.currency.result = res.data.info[i].result * 100; // 差
            this.currency.recommended = res.data.info[i].defRatio * 100; // 推荐比例
            recommendData.push({
              value: this.currency.custRatio,
              name: '货币类',
            });
            proposalData.push({
              value: this.currency.recommended,
              name: '货币类',
            });
          } else if (res.data.info[i].assetsClass === '2') {
            this.fixedincome.custRatio = res.data.info[i].custRatio * 100;
            this.fixedincome.result = res.data.info[i].result * 100;
            this.fixedincome.recommended = res.data.info[i].defRatio * 100;
            recommendData.push({
              value: this.fixedincome.custRatio,
              name: '固收类',
            });
            proposalData.push({
              value: this.fixedincome.recommended,
              name: '固收类',
            });
          } else if (res.data.info[i].assetsClass === '3') {
            this.rightsInterests.custRatio = res.data.info[i].custRatio * 100;
            this.rightsInterests.result = res.data.info[i].result * 100;
            this.rightsInterests.recommended = res.data.info[i].defRatio * 100;
            recommendData.push({
              value: this.rightsInterests.custRatio,
              name: '权益类',
            });
            proposalData.push({
              value: this.rightsInterests.recommended,
              name: '权益类',
            });
          } else if (res.data.info[i].assetsClass === '4') {
            this.commodity.custRatio = res.data.info[i].custRatio * 100;
            this.commodity.result = res.data.info[i].result * 100;
            this.commodity.recommended = res.data.info[i].defRatio * 100;
            recommendData.push({
              value: this.commodity.custRatio,
              name: '商品类',
            });
            proposalData.push({
              value: this.commodity.recommended,
              name: '商品类',
            });
          }
          if (res.data.info[i].conversationArt !== undefined) {
            this.textTwo.push(
              res.data.info[i].conversationArt
                .replace(/<strong>/g, '<span class="Thickening">')
                .replace(/<\/strong>/g, '</span">'),
            );
          }
          this.pieChart('1', recommendData);
          this.pieChart('2', proposalData);
        }
      });
    },
    /**
     * 饼图数据拼接
     * i(1.个人资产饼图2.推荐资产饼图)
     * v：数据
     */
    pieChart(i, v) {
      if (i === '1') {
        this.recommendAssets = {
          title: {
            text: '当前资产结构',
            left: 'center',
          },
          tooltip: {
            trigger: 'item',
            formatter: '{b}: {d}%',
          },
          color: ['#A5A8AC', '#1E88FF', '#34C88B', '#FAB748'],
          series: [
            {
              name: '',
              type: 'pie',
              label: {
                show: false,
              },
              data: v,
            },
          ],
        };
      } else {
        this.proposalAssets = {
          title: {
            text: '建议资产结构',
            left: 'center',
          },
          tooltip: {
            trigger: 'item',
            formatter: '{b}: {d}%',
          },
          color: ['#A5A8AC', '#1E88FF', '#34C88B', '#FAB748'],
          series: [
            {
              name: '',
              type: 'pie',
              label: {
                show: false,
              },
              data: v,
            },
          ],
        };
      }
    },
    // 产品推荐
    prdUnitList() {
      const parames = {
        data: {
          cis: this.customer.cis,
          riskPreference: this.riskLevel.replace(/R/g, ''),
          scheme: this.tabs - 1,
          custRiskLevel: this.riskLevel,
          userId: JSON.parse(sessionStorage.getItem('userId')),
        },
      };
      this.$_post(this.$API.prd_unit_list, parames).then((res) => {
        console.log(res);
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < res.data.info.length; i++) {
          if (res.data.info[i].assetsClass === '1') {
            this.currency.Subitem[0].recommended = res.data.info[i].productRatio * 100;
            this.currency.Subitem[0].product = res.data.info[i].product;
          }
          if (res.data.info[i].assetsClass === '2') {
            if (res.data.info[i].productCategory === '6') {
              this.fixedincome.Subitem[0].recommended = res.data.info[i].productRatio * 100;
              this.fixedincome.Subitem[0].product = res.data.info[i].product;
            }
            if (res.data.info[i].productCategory === '7') {
              this.fixedincome.Subitem[1].recommended = res.data.info[i].productRatio * 100;
              this.fixedincome.Subitem[1].product = res.data.info[i].product;
            }
          }
          if (res.data.info[i].assetsClass === '3') {
            if (res.data.info[i].productCategory === '11') {
              this.rightsInterests.Subitem[0].recommended = res.data.info[i].productRatio * 100;
              this.rightsInterests.Subitem[0].product = res.data.info[i].product;
            }
            if (res.data.info[i].productCategory === '12') {
              this.rightsInterests.Subitem[1].recommended = res.data.info[i].productRatio * 100;
              this.rightsInterests.Subitem[1].product = res.data.info[i].product;
            }
          }
          if (res.data.info[i].assetsClass === '4') {
            this.commodity.Subitem[0].recommended = res.data.info[i].productRatio * 100;
            this.commodity.Subitem[0].product = res.data.info[i].product;
          }
        }
      });
    },
    /**
     * 替换产品按钮方法
     * i为产品类型（1.货币型基金6.银行理财7.债卷11.混合型基金12.股票型基金14.黄金ETF连接基金）
     */
    replacementProducts(i) {
      console.log(i);
      this.productType = i;
      this.replaceDataList();
    },
    // 请求替换列表数据
    replaceDataList(formName) {
      if (formName !== undefined) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            const parames = {
              pageMessage: {
                pageSize: 10,
                pageNo: this.currentPage,
              },
              data: {
                // eslint-disable-next-line no-nested-ternary
                fundType:
                  this.productType === '1'
                    ? '1'
                    : this.productType === '7'
                      ? '5'
                      : this.productType === '11'
                        ? '2'
                        : this.productType === '12'
                          ? '3'
                          : '6',
                prdType: '1',
                customerRiskLevel: this.riskLevel,
                ...this.formInline,
              },
            };
            this.$_post(
              this.productType === '6'
                ? this.$API.finance_list
                : this.$API.fund_list,
              parames,
            ).then((res) => {
              this.gridData = res.data.list;
              this.sumCount = res.sumCount;
              if (this.productType === '1') {
                this.selectData = this.currency.Subitem[0].product;
              }
              if (this.productType === '6') {
                this.selectData = this.fixedincome.Subitem[0].product;
              }
              if (this.productType === '7') {
                this.selectData = this.fixedincome.Subitem[1].product;
              }
              if (this.productType === '11') {
                this.selectData = this.rightsInterests.Subitem[0].product;
              }
              if (this.productType === '12') {
                this.selectData = this.rightsInterests.Subitem[1].product;
              }
              if (this.productType === '14') {
                this.selectData = this.commodity.Subitem[0].product;
              }
              console.log(this.selectData);
              console.log(this.gridData);
              console.log(this.productType);
              this.dialogTableVisible = true;
              this.toggleSelection([this.selectData]);
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      } else {
        const parames = {
          pageMessage: {
            pageSize: 10,
            pageNo: this.currentPage,
          },
          data: {
            // eslint-disable-next-line no-nested-ternary
            fundType:
              this.productType === '1'
                ? '1'
                : this.productType === '7'
                  ? '5'
                  : this.productType === '11'
                    ? '2'
                    : this.productType === '12'
                      ? '3'
                      : '6',
            prdType: '1',
            customerRiskLevel: this.riskLevel,
            ...this.formInline,
          },
        };
        this.$_post(
          this.productType === '6'
            ? this.$API.finance_list
            : this.$API.fund_list,
          parames,
        ).then((res) => {
          this.gridData = res.data.list;
          this.sumCount = res.sumCount;
          if (this.productType === '1') {
            this.selectData = this.currency.Subitem[0].product;
          }
          if (this.productType === '6') {
            this.selectData = this.fixedincome.Subitem[0].product;
          }
          if (this.productType === '7') {
            this.selectData = this.fixedincome.Subitem[1].product;
          }
          if (this.productType === '11') {
            this.selectData = this.rightsInterests.Subitem[0].product;
          }
          if (this.productType === '12') {
            this.selectData = this.rightsInterests.Subitem[1].product;
          }
          if (this.productType === '14') {
            this.selectData = this.commodity.Subitem[0].product;
          }
          console.log(this.selectData);
          console.log(this.gridData);
          console.log(this.productType);
          this.dialogTableVisible = true;
          this.toggleSelection([this.selectData]);
        });
      }
    },
    // 选中产品
    handleCurrentChange(val) {
      if (val.length === 1) {
        this.selectData = val[val.length - 1];
      } else if (val.length > 1) {
        this.selectData = val[val.length - 1];
        this.$refs.multipleTable.clearSelection();
        this.toggleSelection([this.selectData]);
      }
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    // 确定替换
    determineReplacement() {
      console.log(this.productType);
      this.emptyFormInline();
      if (this.productType === '1') {
        this.currency.Subitem[0].product = this.selectData;
      }
      if (this.productType === '6') {
        this.fixedincome.Subitem[0].product = this.selectData;
      }
      if (this.productType === '7') {
        this.fixedincome.Subitem[1].product = this.selectData;
      }
      if (this.productType === '11') {
        this.rightsInterests.Subitem[0].product = this.selectData;
      }
      if (this.productType === '12') {
        this.rightsInterests.Subitem[1].product = this.selectData;
      }
      if (this.productType === '14') {
        this.commodity.Subitem[0].product = this.selectData;
      }
      this.dialogTableVisible = false;
      this.currentPage = 1;
    },
    // 页脚的页数是动态的，所以需要重复调用生成
    async footer() {
      await html2canvas(document.querySelector('#footer')).then((canvas) => {
        // 画布宽度
        const contentWidth = canvas.width;
        // 画布高度
        const contentHeight = canvas.height;
        // 一页pdf显示html页面生成的canvas高度;
        // const pageHeight = (contentWidth / 592.28) * 841.89;
        // 未生成pdf的html页面高度
        // const coverHeight = contentHeight;
        // 页面偏移
        // const position = 0;
        // html页面生成的canvas在pdf中图片的宽高
        this.footerW = 595.28;
        this.footerH = (841.89 / contentWidth) * contentHeight - 20;
        this.footerImg = canvas.toDataURL('image/jpeg', 1.0);
      });
      this.pdf.addImage(
        this.footerImg,
        'JPEG',
        0,
        841.89 - this.footerH,
        this.footerW,
        this.footerH,
      ); // 页脚
      // eslint-disable-next-line no-plusplus
      this.pages++;
    },
    preservationReplace() {
      const replace = [];
      if (this.currency.show) {
        for (let i = 0; i < this.currency.Subitem.length; i++) {
          if (this.currency.Subitem[i].product.prdType !== undefined) {
            const arr = {
              prdCategory: this.currency.Subitem[i].prdCategory,
              prdType: this.currency.Subitem[i].product.prdType,
              prdCode: this.currency.Subitem[i].product.prdCode,
              prdName: this.currency.Subitem[i].product.prdName,
              configType: '1',
            };
            replace.push(arr);
          }
        }
      }
      if (this.fixedincome.show) {
        for (let i = 0; i < this.fixedincome.Subitem.length; i++) {
          if (this.fixedincome.Subitem[i].product.prdType !== undefined) {
            const arr = {
              prdCategory: this.fixedincome.Subitem[i].prdCategory,
              prdType: this.fixedincome.Subitem[i].product.prdType,
              prdCode: this.fixedincome.Subitem[i].product.prdCode,
              prdName: this.fixedincome.Subitem[i].product.prdName,
              configType: '2',
            };
            replace.push(arr);
          }
        }
      }
      if (this.rightsInterests.show) {
        for (let i = 0; i < this.rightsInterests.Subitem.length; i++) {
          if (this.rightsInterests.Subitem[i].product.prdType !== undefined) {
            const arr = {
              prdCategory: this.rightsInterests.Subitem[i].prdCategory,
              prdType: this.rightsInterests.Subitem[i].product.prdType,
              prdCode: this.rightsInterests.Subitem[i].product.prdCode,
              prdName: this.rightsInterests.Subitem[i].product.prdName,
              configType: '3',
            };
            replace.push(arr);
          }
        }
      }
      if (this.commodity.show) {
        for (let i = 0; i < this.commodity.Subitem.length; i++) {
          if (this.commodity.Subitem[i].product.prdType !== undefined) {
            const arr = {
              prdCategory: this.commodity.Subitem[i].prdCategory,
              prdType: this.commodity.Subitem[i].product.prdType,
              prdCode: this.commodity.Subitem[i].product.prdCode,
              prdName: this.commodity.Subitem[i].product.prdName,
              configType: '4',
            };
            replace.push(arr);
          }
        }
      }
      const parames = {
        data: {
          cis: this.customer.cis,
          createUser: this.sessionData.userCode,
          prdUnits: replace,
          scheme: this.tabs - 1,
        },
      };
      this.$_post(this.$API.preservationReplace, parames).then((res) => {
        console.log(res);
      });
    },
    getCustBasicInfo() {
      const parame = {
        data: {
          cis: this.customer.cis,
        },
      };
      this.$_post(this.$API.get_cust_basic_info, parame).then((res) => {
        this.dropDown = res.data.info;
      });
    },
    // 家庭关系图数据
    queryDefaultRelation() {
      const parames = {
        data: {
          // 类型：Object  必有字段  备注：数据集
          cis: this.customer.cis, // 类型：String  必有字段  备注：客户号
          uId: this.sessionData.userId,
        },
      };
      this.$_post(this.$API.wpspListCustSupple, parames).then((res) => {
        const oneself = {
          custName: this.customer.custName,
          custAge: this.customer.age,
          custRelation: '0',
        };
        this.allCustSupple = res.data.allCustSupple;
        this.allCustSupple.unshift(oneself);
        this.allCustSupple.custAge = this.customer.age;
        this.allCustSupple.riskLevel = this.customer.riskLevelRes;
      });
    },
    // 生成报告
    async generatingReports() {
      this.pdf = new jsPDF('', 'pt', 'a4');
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      await this.preservationReplace();
      await this.queryDefaultRelation();
      await this.getCustBasicInfo();
      let coverW = '';
      let coverH = '';
      let coverImg = '';
      // 封面
      await html2canvas(document.querySelector('#cover')).then((canvas) => {
        // 画布宽度
        // const contentWidth = canvas.width;
        // 画布高度
        // const contentHeight = canvas.height;
        // 一页pdf显示html页面生成的canvas高度;
        // const pageHeight = (contentWidth / 592.28) * 841.89;
        // 未生成pdf的html页面高度
        // const coverHeight = contentHeight;
        // 页面偏移
        // const position = 0;
        // html页面生成的canvas在pdf中图片的宽高
        coverW = 595.28;
        coverH = 841.89;
        coverImg = canvas.toDataURL('image/jpeg', 1.0);
      });
      // 页眉
      let headerW = '';
      let headerH = '';
      let headerImg = '';
      await html2canvas(document.querySelector('#header')).then((canvas) => {
        // 画布宽度
        const contentWidth = canvas.width;
        // 画布高度
        const contentHeight = canvas.height;
        // 一页pdf显示html页面生成的canvas高度;
        // const pageHeight = (contentWidth / 592.28) * 841.89;
        // 未生成pdf的html页面高度
        // const coverHeight = contentHeight;
        // 页面偏移
        // const position = 0;
        // html页面生成的canvas在pdf中图片的宽高
        headerW = 595.28;
        headerH = (841.89 / contentWidth) * contentHeight - 20;
        headerImg = canvas.toDataURL('image/jpeg', 1.0);
      });
      // 第一部分
      let statementW = '';
      let statementH = '';
      let statementImg = '';
      await html2canvas(document.querySelector('#statement')).then((canvas) => {
        // 画布宽度
        const contentWidth = canvas.width;
        // 画布高度
        const contentHeight = canvas.height;
        // 一页pdf显示html页面生成的canvas高度;
        // const pageHeight = (contentWidth / 592.28) * 841.89;
        // 未生成pdf的html页面高度
        // const coverHeight = contentHeight;
        // 页面偏移
        // const position = 0;
        // html页面生成的canvas在pdf中图片的宽高
        statementW = 595.28;
        statementH = (841.89 / contentWidth) * contentHeight - 200;
        statementImg = canvas.toDataURL('image/jpeg', 1.0);
      });
      // 第二部分
      let step2W = '';
      let step2H = '';
      let step2Img = '';
      await html2canvas(document.querySelector('#step')).then((canvas) => {
        // 画布宽度
        const contentWidth = canvas.width;
        // 画布高度
        const contentHeight = canvas.height;
        // 一页pdf显示html页面生成的canvas高度;
        // const pageHeight = (contentWidth / 592.28) * 841.89;
        // 未生成pdf的html页面高度
        // const leftHeight = contentHeight;
        // 页面偏移
        // const position = 0;
        // html页面生成的canvas在pdf中图片的宽高
        step2W = 595.28;
        step2H = (841.89 / contentWidth) * contentHeight - 300;
        step2Img = canvas.toDataURL('image/jpeg', 1.0);
      });
      // 第三部分title
      let twoW = '';
      let twoH = '';
      let twoImg = '';
      await html2canvas(document.querySelector('#allCustSupple')).then((canvas) => {
        // 画布宽度
        const contentWidth = canvas.width;
        // 画布高度
        const contentHeight = canvas.height;
        // 一页pdf显示html页面生成的canvas高度;
        // const pageHeight = (contentWidth / 592.28) * 841.89;
        // 未生成pdf的html页面高度
        // const leftHeight = contentHeight;
        // 页面偏移
        // const position = 0;
        // html页面生成的canvas在pdf中图片的宽高
        twoW = 595.28;
        twoH = (841.89 / contentWidth) * contentHeight;
        twoImg = canvas.toDataURL('image/jpeg', 1.0);
      });
      // 资产配置饼图
      let leftW = '';
      let leftH = '';
      let leftImg = '';
      await html2canvas(document.querySelector('#left')).then((canvas) => {
        // 画布宽度
        const contentWidth = canvas.width;
        // 画布高度
        const contentHeight = canvas.height;
        // 一页pdf显示html页面生成的canvas高度;
        // const pageHeight = (contentWidth / 592.28) * 841.89;
        // 未生成pdf的html页面高度
        // const leftHeight = contentHeight;
        // 页面偏移
        // const position = 0;
        // html页面生成的canvas在pdf中图片的宽高
        leftW = 595.28;
        leftH = (841.89 / contentWidth) * contentHeight - 250;
        leftImg = canvas.toDataURL('image/jpeg', 1.0);
      });
      // 推荐产品
      let rightW = '';
      let rightH = '';
      let rightImg = '';
      await html2canvas(document.querySelector('#right')).then((canvas) => {
        // 画布宽度
        const contentWidth = canvas.width;
        // 画布高度
        const contentHeight = canvas.height;
        // 一页pdf显示html页面生成的canvas高度;
        // const pageHeight = (contentWidth / 592.28) * 841.89;
        // 未生成pdf的html页面高度
        // const leftHeight = contentHeight;
        // 页面偏移
        // const position = 0;
        // html页面生成的canvas在pdf中图片的宽高
        rightW = 595.28;
        rightH = (841.89 / contentWidth) * contentHeight - 200;
        rightImg = canvas.toDataURL('image/jpeg', 1.0);
      });
      // 免责条款
      let ExemptionClauseW = '';
      let ExemptionClauseH = '';
      let ExemptionClauseImg = '';
      await html2canvas(document.querySelector('#ExemptionClause')).then(
        (canvas) => {
          // 画布宽度
          const contentWidth = canvas.width;
          // 画布高度
          const contentHeight = canvas.height;
          // 一页pdf显示html页面生成的canvas高度;
          // const pageHeight = (contentWidth / 592.28) * 841.89;
          // 未生成pdf的html页面高度
          // const leftHeight = contentHeight;
          // 页面偏移
          // const position = 0;
          // html页面生成的canvas在pdf中图片的宽高
          ExemptionClauseW = 595.28;
          ExemptionClauseH = (841.89 / contentWidth) * contentHeight - 200;
          ExemptionClauseImg = canvas.toDataURL('image/jpeg', 1.0);
        },
      );
      this.pdf.addImage(coverImg, 'JPEG', 0, 0, coverW, coverH); // 将封面生成pdf
      this.pdf.addPage(); // 新建pdf页面
      this.pdf.addImage(headerImg, 'JPEG', 0, 10, headerW, headerH); // 页眉
      this.pdf.addImage(
        statementImg,
        'JPEG',
        0,
        headerH + 10,
        statementW,
        statementH,
      ); // 第一部分
      await this.footer();
      this.pdf.addPage();
      this.pdf.addImage(headerImg, 'JPEG', 0, 10, headerW, headerH); // 页眉
      this.pdf.addImage(step2Img, 'JPEG', 0, headerH + 10, step2W, step2H);
      await this.footer();
      this.pdf.addPage();
      this.pdf.addImage(headerImg, 'JPEG', 0, 10, headerW, headerH); // 页眉
      this.pdf.addImage(twoImg, 'JPEG', 0, headerH + 10, twoW, twoH);
      this.pdf.addImage(leftImg, 'JPEG', 0, headerH + twoH + 10, leftW, leftH); // 资产配置饼图
      await this.footer();
      this.pdf.addPage();
      this.pdf.addImage(headerImg, 'JPEG', 0, 10, headerW, headerH); // 页眉
      this.pdf.addImage(rightImg, 'JPEG', 0, headerH + 10, rightW, rightH); // 推荐产品
      await this.footer();
      this.pdf.addPage();
      this.pdf.addImage(headerImg, 'JPEG', 0, 10, headerW, headerH); // 页眉
      this.pdf.addImage(
        ExemptionClauseImg,
        'JPEG',
        0,
        headerH + 10,
        ExemptionClauseW,
        ExemptionClauseH,
      ); // 免责条款
      await this.footer();
      this.saveReport(this.pdf.output('datauristring'));
      // console.log(this.pdf.save('content.pdf'));
    },
    // 保存报告
    saveReport(v) {
      const parames = {
        data: {
          custName: this.customer.custName,
          cis: this.customer.cis,
          operatiorName: this.sessionData.userName,
          createUser: this.sessionData.userCode,
          report: v,
        },
      };
      this.$_post(this.$API.saveReport, parames).then((res) => {
        this.loading.close();
        if (res.errorCode === 'E00000') {
          // 向父vue页面发送信息
          window.parent.postMessage({
            cmd: 'returnHeight',
            params: {
              success: true,
              data: this.customer.cis,
            },
          }, '*');
          // window.parent.parenttest();
          // $.busitrans.sendKeyValue('jscall', `refresh('${this.customer.cis}')`);
          // console.log('向外屏传递数据11111111', this.customer.cis);
          // console.log($.busitrans.sendKeyValue('jscall', `refresh('${this.customer.cis}')`));
        }
        this.$message({
          message: res.errorMsg,
          type: 'success',
        });
        window.open(res.data.filePath);
        this.getDetail();
        this.prdUnitList();
        this.preservationScheme();
      });
    },
    // 保存客户方案
    preservationScheme() {
      const parames = {
        data: {
          cis: this.customer.cis,
          scheme: this.tabs - 1,
          riskPreference: this.riskLevel.replace(/R/g, ''),
          custRiskLevel: this.riskLevel,
        },
      };
      this.$_post(this.$API.preservationScheme, parames).then((res) => {
        console.log(res);
      });
    },
  },
};
</script>
<style lang="scss">
.mian-info-tabs {
  display: flex;
  width: 1627px;
  .demo-form-inline {
    .el-form-item {
      width: 305px;
      .el-form-item__label {
        width: 92px;
      }
      .el-form-item__content {
        width: 213px;
      }
    }
    .el-select {
      width: 213px;
    }
  }
  .mian-info-tabs-left {
    width: 50%;
    .chart {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .Arrow {
        width: 28px;
        height: 28px;
      }
    }
    .compare {
      padding-right: 50px;
      > div {
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding: 10px 0px;
        .compare-left {
          .circular {
            display: inline-block;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            margin-right: 12px;
          }
          .text {
            color: rgba(96, 98, 102, 1);
          }
        }
        .Proportion {
          display: inline-block;
          width: 34px;
          font-size: 16px;
          font-weight: 500;
          color: rgba(48, 49, 51, 1);
        }
        .disparity {
          width: 65px;
          color: #02bb6f;
        }
        .disparityOne {
          width: 65px;
          color: rgba(48, 49, 51, 1);
          text-align: center;
        }
        .disparityTwo {
          width: 65px;
          color: #f95353;
        }
      }
    }
    .chart-bottom-text {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      .outerLayer {
        padding: 0px 35px;
        display: flex;
        flex-direction: row;
        .background {
          width: 35px;
          height: 30px;
          background: rgba(30, 136, 255, 0.2);
          font-size: 14px;
          font-weight: normal;
          color: rgba(30, 136, 255, 1);
          font-style: italic;
          text-align: center;
          line-height: 30px;
          margin-right: 10px;
        }
        .Thickening {
          font-weight: 600;
        }
      }
    }
  }
  .right {
    width: 50%;
    .Solid-recovery,
    .Equity {
      margin: 0px;
      .background {
        padding-left: 17px;
        line-height: 40px;
        height: 40px;
        border: 1px solid rgba(238, 238, 238, 1);
        border-left: 2px solid rgba(238, 238, 238, 1);
        border-right: 2px solid rgba(238, 238, 238, 1);
      }
      .product-bottom {
        border: 1px solid rgba(238, 238, 238, 1);
        border-left: 2px solid rgba(238, 238, 238, 1);
        border-right: 2px solid rgba(238, 238, 238, 1);
        .el-row {
          padding: 0px 20px;
          width: 100%;
          height: 40px;
          .el-col {
            height: 40px;
            line-height: 40px;
          }
          .product-type {
            margin-bottom: 10px;
            text-align: center;
            line-height: 22px;
            display: inline-block;
            width: 145px;
            height: 22px;
            font-size: 12px;
            color: rgba(96, 98, 102, 1);
          }
          .color {
            color: rgba(249, 83, 83, 1);
          }
          .product-content {
            margin-bottom: 10px;
            font-size: 12px;
            color: rgba(144, 147, 153, 1);
          }
        }
      }
    }
  }
  .report {
    position: absolute;
    bottom: 1000px;
    background: #fff;
    #cover {
      width: 520px;
      padding: 30px;
      .text {
        :nth-child(1) {
          font-size: 40px;
          font-weight: 500;
          text-align: left;
          color: #000000;
          line-height: 60px;
        }
        :nth-child(2) {
          font-size: 20px;
          font-weight: 400;
          text-align: left;
          color: rgba(0, 0, 0, 0.52);
          line-height: 24px;
        }
      }
      .logo {
        margin-top: 300px;
        text-align: right;
      }
    }
    #header {
      padding: 10px 30px;
      width: 520px;
      .top {
        width: 100%;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #9b9b9b;
        .text {
          font-size: 12px;
          font-weight: SC;
          text-align: left;
          color: #000000;
          line-height: 17px;
          letter-spacing: 0px;
        }
      }
    }
    #footer {
      padding: 10px 30px;
      width: 520px;
      .top {
        width: 100%;
        display: flex;
        justify-content: space-between;
        border-top: 1px solid #9b9b9b;
        font-size: 11px;
        text-align: left;
        color: #303133;
        line-height: 15px;
        letter-spacing: 0px;
      }
    }
    #statement {
      padding: 10px 30px;
      width: 520px;
      .title {
        padding: 10px 0px;
        font-size: 18px;
        font-family: SimHei;
        text-align: left;
        color: #000000;
        line-height: 21px;
      }
      .division {
        width: 520px;
        height: 4px;
        background: linear-gradient(90deg, #c7010e, #ffffff);
      }
      > p {
        font-size: 12px;
        color: #000000;
        line-height: 18px;
        margin: 20px 0px;
      }
      .indent {
        text-indent: 2em;
      }
      .bottom {
        text-align: right;
      }
    }
    .step {
      width: 520px;
      padding:10px 30px;
      font-size: 12px;
      p {
        margin: 10px 0px;
        text-indent: 2em;
      }
       .title {
        padding: 10px 0px;
        font-size: 18px;
        font-family: SimHei;
        text-align: left;
        color: #000000;
        line-height: 21px;
      }
      .division {
        width: 520px;
        height: 4px;
        background: linear-gradient(90deg, #c7010e, #ffffff);
      }
      .contentOne {
        .relationship {
          display: flex;
          justify-content: space-between;
        }
        .el-row {
          text-align: center;
          border: 1px solid #9b9b9b;
          .Header-division {
            border-left: 1px solid #9b9b9b;
            border-right: 1px solid #9b9b9b;
          }
        }
        .Header {
          color: #9b9b9b;
        }
        .content {
          margin: -1px 0px 0px 0px;
        }
        .background {
          background: rgba($color: #c7010e, $alpha: 0.1);
        }
        p {
          margin: 10px 0px;
          text-indent: 2em;
        }
      }
      .contentTwo {
        p {
          margin: 10px 0px;
          text-indent: 2em;
          span {
            color: #c7010e;
          }
        }
        div {
          display: flex;
          flex-direction: row;
          > span {
            display: inline-block;
            width: 20%;
            height: 12px;
            padding: 5px 0px;
            .ArrowShow {
              text-align: center;
              position: relative;
              top: -14px;
              display: flex;
              flex-direction: column;
            }
            .Arrow {
              position: relative;
              top: -3px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            &:nth-child(1) {
              background: rgba(199, 1, 14, 0.1);
            }
            &:nth-child(2) {
              background: rgba(199, 1, 14, 0.3);
            }
            &:nth-child(3) {
              background: rgba(199, 1, 14, 0.5);
            }
            &:nth-child(4) {
              background: rgba(199, 1, 14, 0.7);
            }
            &:nth-child(5) {
              background: rgba(199, 1, 14, 0.9);
            }
          }
        }
      }
    }
    #allCustSupple {
      padding: 10px 30px;
      width: 520px;
      .title {
        padding: 10px 0px;
        font-size: 18px;
        font-family: SimHei;
        text-align: left;
        color: #000000;
        line-height: 21px;
      }
      .division {
        width: 520px;
        height: 4px;
        background: linear-gradient(90deg, #c7010e, #ffffff);
      }
    }
    #right {
      padding: 10px 30px;
      width: 520px;
      .text {
        font-size: 18px;
      }
      .Solid-recovery,
      .Equity {
        margin: 0px;
        .background {
          padding-left: 17px;
          line-height: 40px;
          height: 40px;
          border: 1px solid rgba(238, 238, 238, 1);
          border-left: 2px solid rgba(238, 238, 238, 1);
          border-right: 2px solid rgba(238, 238, 238, 1);
        }
        .product-bottom {
          border: 1px solid rgba(238, 238, 238, 1);
          border-left: 2px solid rgba(238, 238, 238, 1);
          border-right: 2px solid rgba(238, 238, 238, 1);
          .el-row {
            padding: 0px 20px;
            width: 100%;
            height: 20px;
            .el-col {
              height: 20px;
              line-height: 20px;
            }
            .product-type {
              margin-bottom: 10px;
              text-align: center;
              line-height: 22px;
              display: inline-block;
              width: 150px;
              height: 22px;
              font-size: 12px;
              color: rgba(96, 98, 102, 1);
            }
            .color {
              color: rgba(249, 83, 83, 1);
            }
            .product-content {
              margin-bottom: 10px;
              font-size: 12px;
              color: rgba(144, 147, 153, 1);
            }
          }
        }
      }
    }
  }
}
</style>
